import { X } from "lucide-react";
import QuantityInput from "@/theme1/components/cart/QuantityInput";

export default function MiniCartItem({ item, onRemove, onQuantityChange }) {
  return (
    <article className="flex gap-4 rounded-3xl border border-border bg-white p-3">
      <img
        src={item.image}
        alt={item.title}
        className="size-24 rounded-2xl object-cover"
      />

      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="line-clamp-2 text-sm font-bold">{item.title}</h3>
            <p className="mt-1 text-xs text-muted-foreground">
              {item.selectedColor || "Default"} / {item.selectedSize || "One Size"}
            </p>
          </div>

          <button
            type="button"
            onClick={() => onRemove(item)}
            aria-label={`Remove ${item.title}`}
            className="rounded-full p-1 hover:bg-neutral-100"
          >
            <X className="size-4" />
          </button>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <QuantityInput
            value={item.quantity}
            onChange={(quantity) => onQuantityChange(item, quantity)}
          />
          <p className="text-sm font-black">
            ৳{(item.price * item.quantity).toLocaleString()}
          </p>
        </div>
      </div>
    </article>
  );
}